import { PUBLIC_EVENT_ERROR_KEY } from '../constants';
import { PublicEventType } from '../enums';
import { AnyPublicCustomEvent } from '../types';
import { isPublicEventPayload } from './payload';

export const isPublicEventType = (value: unknown): value is PublicEventType =>
  Object.values(PublicEventType).includes(value as PublicEventType);

export const isPublicEvent = (event: Event): event is AnyPublicCustomEvent => {
  if (!(event instanceof CustomEvent)) return false;
  const { type, detail } = event;

  if (!isPublicEventType(type)) {
    throw new Error(
      `${PUBLIC_EVENT_ERROR_KEY} Receive invalid public event type: ${type}`
    );
  }

  if (!isPublicEventPayload(type, detail)) {
    throw new Error(
      `${PUBLIC_EVENT_ERROR_KEY} Receive invalid payload for public event type: ${type}`
    );
  }

  return true;
};
